// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"e3f98ff5","769":"739ecede"}[chunkId] + ".chunk.js";
};